"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NoMatchStyle = {
    position: "absolute",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "60px",
    fontWeight: 100,
    color: "#999"
};

exports.default = function () {
    return _react2.default.createElement(
        "div",
        { style: NoMatchStyle },
        "404"
    );
};


//////////////////
// WEBPACK FOOTER
// ./packages/bone-web@0.2/node_modules/_@bone_web@0.2.0-alpha.7@@bone/web/lib/NoMatch.js
// module id = 2549
// module chunks = 4